import styled from "styled-components";

export const DeleteButton = styled.div`
  background: #f55;
  border-radius: 50%;
  min-width: 34px;
  width: 34px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  padding: 0;
  cursor: pointer;
`;
